import {
    LongTermLeaseFeesType,
} from 'app/Apps/Pricing/ContractBasis/LongTermLeaseFees/LongTermLeaseFees.types'
import {
    BillingCompany,
} from 'app/Apps/ContactManagement/BillingCompanies/BillingCompanyForm.types'
import DomainObjectForm from 'app/shared-components/DomainObjectForm'
import useEnumValues from 'app/hooks/useEnumValues'
import useFieldsWithClassName from 'app/hooks/useFieldsWithClassName'
import {
    LongTermLeaseType,
} from 'app/Apps/OrderManagement/LongTermLease/longTermLease.types'

import getGeneralInfoFields from './generalInfo.fields'
import useStyles from './generalInfo.styles'

const GeneralInfo = ({
    longTermLeaseFees,
    billingCompany,
    longTermLease,
}: Readonly<{
    longTermLeaseFees: LongTermLeaseFeesType,
    longTermLease: LongTermLeaseType,
    billingCompany: BillingCompany,
}>) => {
    const {
        classes,
    } = useStyles()

    const getAllowedValues = useEnumValues()

    const fields = useFieldsWithClassName(getGeneralInfoFields({
        getAllowedValues,
        longTermLease,
        longTermLeaseFees,
        billingCompany,
    }), classes)

    return (
        <DomainObjectForm
            name="LongTermLeaseInvoiceGeneralInfo"
            fields={fields}
            className={classes.gridWrapperOrder}
            disabled
        />
    )
}

export default GeneralInfo
